import React, { useContext, useEffect } from "react";

import { makeStyles } from "@material-ui/core";

import { Box, Paper, styled, Typography, useTheme } from "@mui/material";
import { SidebarBottomItems, SideBarItems } from "../utils/staticDataJson";
import palette from "../theme/palette";
import { useLocation, useNavigate } from "react-router-dom";
import clsx from "clsx";
import { UserTypeContext } from "../context/userStatus";
import { categoryService } from "../services/category";
import { getActive } from "../utils/getActiveRoute";
import { addCategoryExpandAction, addCategoryJourneyAction, addInfluenceAction, addJourneyAction, addNotesAction, addNotesJourneyAction, addOutcomeAction, addRefelectiveAction, isPersonalMode, setOpenSubscriptionModal, setUserResetOnLogout } from "../store/actions/userTypeAction";
import { ContactsContext } from "../context/userIContacts";
import { setShareModalOpen } from "../store/actions/contactsActions";
import { setTrackingState } from "../store/actions/trackerAction";
import { TrackingContext } from "../context/userTracking";
import CommonTypo from "./CommonTypo";
import { UserNotificationContext } from "../context/userNotification";
import { setAlreadyCalled, updateNotificationData } from "../store/actions/notificationActions";

const LogoNew = () => {
  return <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#ADE888" />
    <path d="M37.3832 22.694L35.0804 22.0933C34.6828 19.8048 33.5884 17.6948 31.9468 16.0516C30.3052 14.4084 28.1963 13.312 25.9082 12.9121L25.3019 10.6126C25.2263 10.3237 25.0572 10.068 24.8209 9.88551C24.5845 9.703 24.2943 9.604 23.9957 9.604C23.6971 9.604 23.407 9.703 23.1706 9.88551C22.9343 10.068 22.7651 10.3237 22.6896 10.6126L22.0889 12.9155C19.7991 13.3136 17.6883 14.4093 16.0449 16.0527C14.4015 17.6961 13.3059 19.8069 12.9077 22.0966L10.6082 22.694C10.3193 22.7695 10.0636 22.9387 9.88112 23.175C9.69861 23.4113 9.59961 23.7015 9.59961 24.0001C9.59961 24.2987 9.69861 24.5889 9.88112 24.8252C10.0636 25.0616 10.3193 25.2307 10.6082 25.3063L12.9077 25.9126C13.3059 28.2023 14.4015 30.3132 16.0449 31.9566C17.6883 33.5999 19.7991 34.6956 22.0889 35.0938L22.6896 37.3876C22.7651 37.6765 22.9343 37.9322 23.1706 38.1147C23.407 38.2973 23.6971 38.3963 23.9957 38.3963C24.2943 38.3963 24.5845 38.2973 24.8209 38.1147C25.0572 37.9322 25.2263 37.6765 25.3019 37.3876L25.9082 35.0881C28.1961 34.6893 30.3052 33.594 31.9474 31.9518C33.5896 30.3096 34.6849 28.2005 35.0837 25.9126L37.3832 25.3063C37.6721 25.2307 37.9278 25.0616 38.1104 24.8252C38.2929 24.5889 38.3919 24.2987 38.3919 24.0001C38.3919 23.7015 38.2929 23.4113 38.1104 23.175C37.9278 22.9387 37.6721 22.7695 37.3832 22.694ZM32.1092 21.3181L27.7994 20.1931L26.6744 15.8833C27.9409 16.3042 29.0918 17.0145 30.0358 17.958C30.9798 18.9014 31.6909 20.0519 32.1126 21.3181H32.1092ZM22.7942 20.8929L23.9957 16.2984L25.1939 20.8929L23.9957 22.0876L22.7942 20.8929ZM23.9957 25.9126L25.1939 27.1108L23.9957 31.7019L22.7976 27.1074L23.9957 25.9126ZM20.8885 22.8054L22.0832 24.0001L20.8851 25.1983L16.294 24.0001L20.8885 22.8054ZM27.103 25.2016L25.9082 24.0001L27.1064 22.802L31.6975 24.0001L27.103 25.2016ZM21.3137 15.8866L20.1887 20.1965L15.8789 21.3215C16.2998 20.055 17.0101 18.9041 17.9536 17.96C18.897 17.016 20.0475 16.305 21.3137 15.8833V15.8866ZM15.8789 26.6866L20.1887 27.8116L21.3137 32.1215C20.0474 31.6997 18.8968 30.9884 17.9534 30.0442C17.0099 29.1 16.2996 27.9488 15.8789 26.6821V26.6866ZM26.6789 32.1215L27.8039 27.8116L32.1137 26.6866C31.6917 27.9518 30.9807 29.1012 30.0371 30.0438C29.0935 30.9864 27.9433 31.6962 26.6777 32.117L26.6789 32.1215Z" fill="black" />
  </svg>
}

const RootStyle = styled("div")(({ theme }) => ({
  backgroundColor: "var(--white-background)",
  // backgroundColor: '#F7F9FA',
  // position: "relative",
  // height: "calc(100vh - 5%)",
  display: 'flex',
  width: '100%',
  height: '100vh',
  padding: '48px 24px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: "space-between",
  gap: '24px',
  flexShrink: 0,
  position: 'relative'
}));
const SideBarItem = styled("div")(({ theme }) => ({
  width: "100%",
  height: "44px",
  margin: '0',
  padding: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  cursor: "pointer",
  // border: '1px solid black',
  [theme.breakpoints.up("xl")]: {},
  [theme.breakpoints.up("lg")]: {},
  [theme.breakpoints.down("md")]: {},
  [theme.breakpoints.down("sm")]: {},
}));
const MenuItems = styled(Typography)(({ theme }) => ({
  marginLeft: "8px",
  // border: '1px solid black',
  [theme.breakpoints.up("xl")]: {},
  [theme.breakpoints.up("lg")]: {},
  [theme.breakpoints.down("md")]: {},
  [theme.breakpoints.down("sm")]: {},
}));
const useStyles = makeStyles((theme) => ({
  userCardNormal: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    margin: "40px 0px 40px 0px",
    padding: "8px 20px 6px 24px",
    // backgroundColor: "#FAFAFA!important",
  },
  userCardExpand: {
    margin: "40px 0px 40px 0px",
    display: "flex",
    justifyContent: "center",
    padding: "8px 16px",
    // backgroundColor: "#FAFAFA!important",
    [theme.breakpoints.down("lg")]: {
      padding: "5px",
    },
  },
  userText: {
    textAlign: "center",
    marginLeft: "10px!important",
    marginTop: "10px!important",
    fontSize: "16px!important",
    lineHeight: "16px!important",
    color: `var(--color-text-primary)!important`,
    maxWidth: "100px",
    [theme.breakpoints.down("md")]: {
      fontSize: "12px!important",
    },
  },
  list: {
    padding: "0",
    margin: "0",
    height: "100%",
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    overflowY: "auto"
  },
  listBottom: {
    padding: "0",
    margin: "0",
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    overflowY: "auto"
  },
  prodcustName: {
    height: "24px",
    width: "24px",
    fontSize: '24px !important',
    color: '#11734A !important'
  },
  listItem: {
    padding: "12px",
    display: "flex",
    alignItems: "center",
    borderRadius: "0!important",
    [theme.breakpoints.down("md")]: {
      padding: "10px",
    },
    "& li": {
      listStyle: "none",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "14px",
      marginLeft: "12px",
      color: "var(--color-black)",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
      },
    },
    "&:hover": {
      // backgroundColor: "#EBF0F2!important",
      cursor: "pointer",
    },
  },
  logoutItem: {
    position: 'absolute',
    bottom: '0px',
    padding: "18px 24px",
    display: "flex",
    alignItems: "center",
    // backgroundColor: "#FAFAFA!important",
    borderRadius: "0!important",
    [theme.breakpoints.down("md")]: {
      padding: "10px",
    },
    "& li": {
      listStyle: "none",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "16px",
      marginLeft: "12px",
      color: "var(--color-text-primary)",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
      },
    },
    "&:last-child": {
      position: "absolute",
      bottom: "0px",
      marginBottom: "0px",
      zIndex: "1",
      width: "100%",
    },

    "&:hover": {
      color: "#EBF0F2!important",
      cursor: "pointer",
    },
  },
  blogItem: {
    position: 'absolute',
    bottom: '100px',
    padding: "18px 24px",
    display: "flex",
    alignItems: "center",
    // backgroundColor: "#FAFAFA!important",
    borderRadius: "0!important",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      padding: "10px",
    },
    "& li": {
      listStyle: "none",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "16px",
      marginLeft: "12px",
      color: "var(--sidebar-secondary-label)",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
      },
    },
    "&:last-child": {
      position: "absolute",
      bottom: "10px",
      marginBottom: "10px",
      zIndex: "1",
      width: "100%",
    },

    "&:hover": {
      color: "#EBF0F2!important",
      cursor: "pointer",
    },
  },
  faqItem: {
    position: 'absolute',
    bottom: '60px',
    padding: "18px 24px",
    display: "flex",
    alignItems: "center",
    // backgroundColor: "#FAFAFA!important",
    borderRadius: "0!important",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      padding: "10px",
    },
    "& li": {
      listStyle: "none",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "16px",
      marginLeft: "12px",
      color: "var(--sidebar-secondary-label)",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
      },
    },
    "&:last-child": {
      position: "absolute",
      bottom: "10px",
      marginBottom: "10px",
      zIndex: "1",
      width: "100%",
    },

    "&:hover": {
      color: "#EBF0F2!important",
      cursor: "pointer",
    },
  },
  sidebarBottomMenuItems: {
    // position: 'absolute',
    // bottom: 0,
    // marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '8px',
    width: '100%',
    margin: "0",
    overflowY: "auto"
  }
}));

interface SideBarModal {
  isExpandMode: boolean;
  setIsExpandMode?: Function;
}

const SideBar = (props: SideBarModal) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const pathName = useLocation();
  const { state: outcomeState, dispatch: userTypeDispatch } = useContext(UserTypeContext);
  const { state: IContactTypeState, dispatch: contactsDispatch } =
    useContext(ContactsContext);
  const { dispatch: notificationDispatch } =
    useContext(UserNotificationContext);
  const { dispatch: trackingDispatch } =
    useContext(TrackingContext);
  const isDarkMode = useTheme().palette.mode === "dark" || outcomeState.isDarkMode
  useEffect(() => {
    getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCategories = () => {
    categoryService
      .getCategories(outcomeState.token)
      .then((data: any) => {
        const newArry = data?.data?.map((ele, index) => {
          return {
            ...ele,
            arrayIndex: index,
          };
        });
        localStorage.setItem("categoryCount", `${newArry.length}`);
      })
      .catch((error) => {
        console.log("category list error", error);
      });
  };

  return (
    <>
      <RootStyle className="sidebar" style={props.isExpandMode ? { padding: '48px 24px', maxWidth: "120px" } : {}}>
        <Box display={"flex"} flexDirection={"column"} gap={"32px"} alignSelf={"stretch"}>
          <div style={{
            width: '100%',
            display: 'flex',
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            gap: "16px",
            paddingRight: "0px",
          }}>
            <LogoNew />
            <CommonTypo size={12} lineHeight={12} fontWeight={700} color="var(--color-text-primary)">{props?.isExpandMode ? "TNT" : "Tenacious Tracker"}</CommonTypo>
          </div>
          <div className={classes.list}>
            {SideBarItems.filter(it => it).map((item) => {
              const isActiveOPath = getActive(item.route, pathName?.pathname, item?.children)
              let extraStyles = {}
              if (isActiveOPath) {
                extraStyles = {
                  background: isDarkMode ? "var(--dark-surface)" : "#F6F6F6"
                }
              }
              if (item.route === "/insight-progress") {
                extraStyles = {
                  ...extraStyles,
                  justifyContent: "space-between"
                }
              }
              return (
                <Paper
                  sx={{
                    justifyContent: props.isExpandMode ? "center" : "flex-start",
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    // padding: item.text === "Logout" ? '16px 0px 0px' : '16px 0px !important',
                    padding: '12px',
                    width: "100%",
                    height: "44px",
                    backgroundColor: "transparent",
                    ...extraStyles
                  }}
                  elevation={0}
                  className={
                    item.text === "Logout" ? classes.logoutItem : item.text === "Blog" ? classes.blogItem : item.text === "FAQ" ? classes.faqItem : getActive(item.route, pathName?.pathname, item?.children)
                      ? clsx(classes.listItem, "listItem active")
                      : clsx(classes.listItem, "listItem")
                  }
                  key={item.text}
                  onClick={() => {
                    if (item.text === "Logout") {
                      localStorage.removeItem("userDetails");
                      localStorage.removeItem("userValues");
                      localStorage.removeItem("userId");
                      localStorage.removeItem("userDate");
                      localStorage.removeItem("trackQuote");
                      localStorage.removeItem("categoryCount");
                      localStorage.removeItem("menuExpandableIds")
                      userTypeDispatch(addCategoryJourneyAction([]));
                      userTypeDispatch(addNotesJourneyAction([]));
                      userTypeDispatch(addOutcomeAction([]));
                      userTypeDispatch(addInfluenceAction([]));
                      userTypeDispatch(addRefelectiveAction([]));
                      userTypeDispatch(addJourneyAction([] as any));
                      userTypeDispatch(addNotesAction([] as any));
                      userTypeDispatch(addCategoryExpandAction([] as any));
                      userTypeDispatch(isPersonalMode(false))
                      trackingDispatch(setTrackingState({
                        calendar: []
                      }))

                    }
                    if (item.text === "Blog") {
                      window.open("https://blog.tenacious-tracker.com", "_blank")
                      return
                    }
                    if (item.text === "Social reports") {
                      if (outcomeState.restrictUser) {
                        userTypeDispatch(setOpenSubscriptionModal(true))
                      } else {
                        contactsDispatch(setShareModalOpen(true))
                      }
                      return
                    }
                    navigate(item.route);
                  }}
                >
                  {item.route === "/insight-progress" && !props.isExpandMode ? (
                    <>
                      <Box display={"flex"} alignItems={"center"} >
                        {item.icon(undefined, isActiveOPath ? isDarkMode : false)}
                        {!props.isExpandMode && <li style={{
                          zIndex: 1, fontWeight: isDarkMode && isActiveOPath ? 600 : 400,
                          fontSize: '12px',
                          ...(isDarkMode ? { color: isActiveOPath ? "var(--dark-text-primary)" : "var(--color-text-primary)" } : {}),
                        }}>{item.text}</li>}
                      </Box>
                      {outcomeState?.userDetails?.celebrationData?.totalCount > 0 && <Box width="29px"
                        height="18px"
                        borderRadius="6px"
                        border={"2px solid var(--color-new-main)"}
                        // padding={"4px 8px"}
                        display={"flex"}
                        gap={"1px"}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        <CommonTypo size={12} lineHeight={14} color="var(--color-text-primary)" extraSx={{
                           position: 'relative',
                           top: '-1px', // try 1px or 2px depending on how off it looks
                        }}>
                          +
                        </CommonTypo>
                        <CommonTypo size={12} lineHeight={14} color="var(--color-text-primary)">
                          {outcomeState?.userDetails?.celebrationData?.totalCount}
                        </CommonTypo>

                      </Box>}
                    </>
                  ) :
                    <>
                      {item.icon(undefined, isActiveOPath ? isDarkMode : false)}
                      {!props.isExpandMode && <li style={{
                        zIndex: 1, fontWeight: 400,
                        fontSize: '12px',
                        ...(isDarkMode ? { color: isActiveOPath ? "var(--dark-text-primary)" : "var(--color-text-primary)" } : {}),
                      }}>{item.text}</li>}
                    </>}

                </Paper>
              )
            })}
          </div>
        </Box>

        {/* <div className={classes.sidebarBottomMenuItems} style={{
          left: props.isExpandMode && '0px'
        }}> */}
        <Box display={"flex"} flexDirection={"column"} gap={"32px"} style={{
          width: props?.isExpandMode ? "48px" : "165px"
        }}>
          <div className={classes.listBottom}>
            {SidebarBottomItems.map(item => {
              return <SideBarItem /* className={classes.sideBarLogoutButton} */ style={{
                justifyContent: props.isExpandMode ? 'center' : 'flex-start',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                // padding: item.text === "Logout" ? '16px 0px 0px' : '16px 0px !important',
                padding: '12px',
                width: "100%",
                height: "44px",
              }} onClick={() => {
                if (item.text === "Logout") {
                  localStorage.removeItem("userDetails");
                  localStorage.removeItem("userValues");
                  localStorage.removeItem("userId");
                  localStorage.removeItem("userDate");
                  localStorage.removeItem("trackQuote");
                  localStorage.removeItem("categoryCount");
                  localStorage.removeItem("menuExpandableIds")
                  userTypeDispatch(addCategoryJourneyAction([]));
                  userTypeDispatch(addNotesJourneyAction([]));
                  userTypeDispatch(addOutcomeAction([]));
                  userTypeDispatch(addInfluenceAction([]));
                  userTypeDispatch(addRefelectiveAction([]));
                  userTypeDispatch(addJourneyAction([] as any));
                  userTypeDispatch(addNotesAction([] as any));
                  userTypeDispatch(addCategoryExpandAction([] as any));
                  userTypeDispatch(isPersonalMode(false))
                  userTypeDispatch(setUserResetOnLogout())
                  trackingDispatch(setTrackingState({
                    calendar: [],
                    isLastAlreadyLoaded: false,
                    showLoader: false
                  }))
                  notificationDispatch(updateNotificationData([]))
                  notificationDispatch(setAlreadyCalled(false))
                }
                if (item.text === "Blog") {
                  window.open("https://blog.tenacious-tracker.com", "_blank")
                  return
                }
                navigate(item.route);
              }}>
                {item.icon}
                {/* <img src={Blog} alt="" className={classes.sidebarBottomIcon} /> */}
                {!props.isExpandMode && (
                  <MenuItems variant="body2" sx={{ ml: "8px", color: "var(--color-text-primary)" }}>
                    {item.text}
                  </MenuItems>)}
              </SideBarItem>
            })}
          </div>
        </Box>


      </RootStyle >
      <Box sx={{
        position: "absolute",
        top: "50%",
        right: "-16px",
        height: "36px",
        width: "36px",
        borderRadius: "100%",
        padding: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px 4px 8px 0px #0000001A",
        background: "var(--white-background)",
        zIndex: 9,
        cursor: "pointer"
      }} onClick={() => {
        props?.setIsExpandMode(!props?.isExpandMode)
        localStorage.setItem("isExpandMode", `${!props?.isExpandMode}`)
      }}>
        <Box sx={{
          transform: props?.isExpandMode ? "rotate(180deg)" : "rotate(0px)"
        }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8374 16.9132L5.58744 10.6632C5.50004 10.5761 5.43069 10.4727 5.38337 10.3587C5.33606 10.2447 5.3117 10.1226 5.3117 9.99918C5.3117 9.87579 5.33606 9.75362 5.38337 9.63967C5.43069 9.52571 5.50004 9.42222 5.58744 9.33512L11.8374 3.08512C12.0136 2.909 12.2524 2.81006 12.5015 2.81006C12.7506 2.81006 12.9894 2.909 13.1656 3.08512C13.3417 3.26124 13.4406 3.50011 13.4406 3.74918C13.4406 3.99826 13.3417 4.23713 13.1656 4.41325L7.57884 9.99996L13.1663 15.5867C13.3425 15.7628 13.4414 16.0017 13.4414 16.2507C13.4414 16.4998 13.3425 16.7387 13.1663 16.9148C12.9902 17.0909 12.7514 17.1899 12.5023 17.1899C12.2532 17.1899 12.0143 17.0909 11.8382 16.9148L11.8374 16.9132Z" fill="var(--color-text-secondary)" />
          </svg>

        </Box>

      </Box>
    </>

  );
};

export default SideBar;
